import { Checkbox, Field } from '@fluentui/react-components';

import { useDeviceDrawerStore } from '../../store/DeviceDrawerStore';
import { CategoryStateProps, InputStateProps } from '../../hooks/useDeviceFormHook';

import BodyPresenceMotion from './BodyPresenceMotion';
import BaseOptionCombobox from '../../../../components/BaseOptionCombobox';


type DeviceInfoProps = {
    styles: string;
    vendorState: CategoryStateProps;
    manufacturerState: CategoryStateProps;
    modelState: CategoryStateProps;
    laptopBagState: InputStateProps<boolean>;
}

export default function DeviceInfo({ styles, vendorState, manufacturerState, modelState, laptopBagState }: DeviceInfoProps) {
    const { isForward, level } = useDeviceDrawerStore();

    return (
        <BodyPresenceMotion
            isForward={isForward}
            visible={level === 2}
            unmountOnExit={true}
        >
            <div className={styles}>
                <Field label={"Vendor"} required={true} >
                    <BaseOptionCombobox
                        id={vendorState.id}
                        data={vendorState.list?.options}
                        defaultValue={vendorState.value?.toString() ?? ""}
                        disabled={false}
                        onChange={vendorState.setValue}
                    />
                </Field>

                <Field label={"Manufacturer"} required={true} >
                    <BaseOptionCombobox
                        id={manufacturerState.id}
                        data={manufacturerState.list?.options}
                        defaultValue={manufacturerState.value?.toString() ?? ""}
                        disabled={false}
                        onChange={manufacturerState.setValue}
                    />
                </Field>

                <Field label={"Model"} required={true} >
                    <BaseOptionCombobox
                        id={modelState.id}
                        data={modelState.list?.options}
                        defaultValue={modelState.value?.toString() ?? ""}
                        disabled={false}
                        onChange={modelState.setValue}
                    />
                </Field>

                <Field label={"Laptop Bag"}>
                    <Checkbox
                        id={laptopBagState.id}
                        checked={laptopBagState.value}
                        onChange={(_, data) => laptopBagState.setValue(Boolean(data.checked) ?? false)}
                    />
                </Field>
            </div>
        </BodyPresenceMotion>
    );
}